import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { ImageReveal } from "@/components/Reveal";

export function ArticleCard({ article, testid }) {
  return (
    <Link
      to={`/education/${article.slug}`}
      data-testid={testid || `article-card-${article.slug}`}
      className="group flex h-full flex-col overflow-hidden border border-line bg-white transition-colors hover:border-electric"
    >
      <ImageReveal
        src={article.image}
        alt={article.title}
        className="aspect-[16/10]"
        imgClassName="transition-transform duration-700 group-hover:scale-105"
      />
      <div className="flex flex-1 flex-col p-6">
        <div className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.14em] text-electric">
          {article.categoryLabel}
          <span className="flex items-center gap-1 text-slatey">
            <Clock className="h-3 w-3" /> {article.readingTime}
          </span>
        </div>
        <h3 className="mt-4 flex-1 font-heading text-xl font-medium leading-snug text-navy transition-colors group-hover:text-electric">
          {article.title}
        </h3>
        <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-slatey">
          {article.excerpt}
        </p>
        <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-electric">
          Read article
          <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  );
}
